/**
 * Created by noOne on 12/10/2017.
 */

/**
 * @class
 */
export default class Sprite3D extends PIXI.projection.Sprite2d {
    /**
     * @param texName {String} - texture name
     * @param holder {*|PIXI.projection.Container2d} - optional holder to add to
     */
    constructor(texName, holder) {
        super(PIXI.Texture.EMPTY);//init to an empty texture

        if (holder) holder.addChild(this);//if passed in holder add this to ti
        if (texName && typeof texName === "string") {
            /**
             * @type {PIXI.Sprite|Sprite2d}
             * @private
             */
            this._view = new PIXI.Sprite(Common.assets.texture(texName));
            this._view.anchor.set(0.5, 1.0);
            this.addChild(this._view);
        } else {
            //  this._view = new PIXI.projection.Sprite2d(PIXI.Texture.EMPTY);
            this._view = new PIXI.Sprite(PIXI.Texture.EMPTY);
        }
        this._setupProjection();
    }

    /**
     * @private
     */
    _setupProjection() {
        //this.factor = 1;
        this.proj.affine = PIXI.projection.AFFINE.AXIS_X;
        this.anchor.set(0.5, 0.0);
    }

    get view() {
        return this._view;
    }

    set view(value) {
        this._view = value;
    }
}